import {HISTORY_RECORD_TIME, MAX_HISTORY_COUNT} from "@/Const";
import {isString} from "@/utils";
import {ipcInvoke} from "@/common/ipc";

let mProjectHistory:any;
let mProjectHistoryDoc:any;

export function initProjectHistory(db:any){
    mProjectHistory = db.table('projectHistory');
    mProjectHistoryDoc = db.table('projectHistoryDoc');
}

export const projectHistoryList = (szId:any)=>{
    return mProjectHistory.where('projectId').equals(szId).toArray();
}

/**
 * 所有历史记录
 */
export const projectAllHistoryList = ()=>{
    return mProjectHistory.toArray();
}

/**
 * 最新的历史记录的保存时间
 */
const hasBeyondLastestTime = (szId:any)=>{
    return new Promise(async (resolve) => {
        const arrayHistory = await mProjectHistory.where('projectId').equals(szId).toArray();
        arrayHistory.sort((a,b)=>{//降序
            return b.historyTime - a.historyTime;
        })
        //只保存最新的10-20个
        if (arrayHistory.length > MAX_HISTORY_COUNT){
            const arrayOld = arrayHistory.slice(MAX_HISTORY_COUNT,(arrayHistory.length - MAX_HISTORY_COUNT));
            for (let i=0;i<arrayOld.length;i++){
                await deleteProjectHistory(arrayOld[i].id,szId);
            }
        }

        if (arrayHistory.length > 0){
            resolve((Date.now() - arrayHistory[0].historyTime) > HISTORY_RECORD_TIME);
        }else{
            resolve(true);
        }
    })
}

/**
 * 更新历史记录
 * @param card
 * @param doc
 */
export const updateProjectHistory = async (project:any)=>{
    const bNeedSave = await hasBeyondLastestTime(project.id);
    if (bNeedSave){
        var newProject = {...project};
        newProject.projectId = newProject.id;
        delete newProject.id;
        delete newProject.isHover;
        delete newProject.isSelected;

        newProject.historyTime = Date.now();

        var newDoc = {
            projectId:newProject.projectId,
            data:newProject.doc
        }

        newProject.doc = '';
        mProjectHistory.put(newProject).then(id=>{
            newDoc.id = id;
            // mProjectHistoryDoc.put(newDoc);
            let szDoc = newDoc.data;
            if (!isString(szDoc)){
                szDoc = JSON.stringify(szDoc);
            }
            //保存到文件....
            ipcInvoke('save-project',{projectId:project.id,historyId:id,doc:szDoc});
        });

    }
}

export const updateProjectHistoryDoc = async (szId:any,szDoc:any)=>{
    mProjectHistoryDoc.put({
        id:szId,
        data:szDoc
    })
}

/**
 * 删除历史记录
 * @param id
 */
export const deleteProjectHistory = async (id:any,projectId:any = null)=>{
    mProjectHistory.delete(id);
    mProjectHistoryDoc.delete(id);
    if (projectId){
        ipcInvoke('delete-project',{projectId:projectId,historyId:id})
    }

    return 'ok';
}

/**
 * 清空历史记录表
 */
export const clearProjectHistoryDoc = ()=>{
    mProjectHistoryDoc.clear();
}

/**
 * 历史记录----doc文档
 * @param id
 */
export const projectHistoryDoc = (id)=>{
    return new Promise(async (resolve) => {
        // const docData = await mProjectHistoryDoc.get(id);
        // if (docData){
        //     if (isString(docData.data)){
        //         resolve(docData.data);
        //     }else{
        //         resolve(JSON.stringify(docData.data));
        //     }
        // }else{
        //     resolve(null);
        // }
        const projectHistory = await mProjectHistory.get(id);
        if (projectHistory){
            const docData = await ipcInvoke('read-project',{projectId:projectHistory.projectId,historyId:id});
            if (docData){
                resolve(docData);
            }else{
                resolve(null);
            }
        }
    })
}

